module.exports = __webpack_public_path__ + "img/71.b3925f0d.jpg";